(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interior-decoration-enquiry"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initEnquiry(root) {
      if (!root || root.dataset.enqInit) return;
      root.dataset.enqInit = '1';

      var form = root.querySelector('form.enquiry__form');
      if (!form) return;

      var waNumber = (root.dataset.wa || '').replace(/\D/g, '');
      var webhook  = root.dataset.webhook || '';
      var useGA4   = root.dataset.ga4 === 'true';
      var useMeta  = root.dataset.meta === 'true';
      var tmpl     = root.dataset.waTemplate || "Hi GEORGES, I'd love help with my [rooms] (budget [budget]). My name is [name].";
      var loadedAt = Date.now();

      /* Attribution: capture UTMs / landing page, persist for the session */
      try {
        var qs = new URLSearchParams(window.location.search);
        var stored = JSON.parse(sessionStorage.getItem('god_attr') || '{}');
        ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'].forEach(function (k) {
          if (qs.get(k)) stored[k] = qs.get(k);
        });
        if (!stored.landing) stored.landing = window.location.pathname + window.location.search;
        if (!stored.referrer) stored.referrer = document.referrer || '';
        sessionStorage.setItem('god_attr', JSON.stringify(stored));
        root.querySelectorAll('[data-attr]').forEach(function (el) {
          var key = el.getAttribute('data-attr');
          el.value = key === 'landing' ? (stored.landing || '') : (stored[key] || '');
        });
      } catch (err) {}

      form.setAttribute('novalidate', 'novalidate');

      var fields = Array.prototype.slice.call(form.querySelectorAll('.field, .contactFormSelect'));
      function fieldBlock(el) { return el.closest('.custom-form__block'); }
      function setState(el) {
        var b = fieldBlock(el); if (!b) return true;
        var touched = el.dataset.touched === '1';
        var valid = el.checkValidity();
        var filled = !!el.value;
        b.classList.toggle('has-error', touched && !valid);
        b.classList.toggle('is-valid', touched && valid && el.hasAttribute('required') && filled);
        el.setAttribute('aria-invalid', (touched && !valid) ? 'true' : 'false');
        return valid;
      }
      /* Validate live: red the moment a required field is wrong, and clear it the instant it's fixed */
      fields.forEach(function (el) {
        el.addEventListener('blur', function () { el.dataset.touched = '1'; setState(el); });
        el.addEventListener('input', function () { if (el.dataset.touched === '1') setState(el); });
        el.addEventListener('change', function () { el.dataset.touched = '1'; setState(el); });
      });

      /* Post-submit: the native submit reloaded the page to Shopify's confirmation screen.
         If we saved answers just before that submit, personalise the WhatsApp button and fire
         the lead analytics once (the saved data is cleared so a refresh won't double-count). */
      try {
        var enq = JSON.parse(sessionStorage.getItem('god_enq') || 'null');
        if (enq) {
          sessionStorage.removeItem('god_enq');
          var waBtn = root.querySelector('[data-enq-wa]');
          if (waBtn && waNumber && (enq.name || enq.rooms || enq.budget)) {
            var msg = tmpl.replace('[name]', enq.name || '').replace('[rooms]', enq.rooms || '').replace('[budget]', enq.budget || '');
            waBtn.setAttribute('href', 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg));
          }
          try { if (useGA4 && window.gtag) gtag('event', 'generate_lead', { currency: 'AED', budget_band: enq.budget, form: 'interior_decoration' }); } catch (eA) {}
          try { if (useMeta && window.fbq) fbq('track', 'Lead', { content_name: 'Interior Decoration enquiry' }); } catch (eB) {}
          try { window.dataLayer = window.dataLayer || []; dataLayer.push({ event: 'generate_lead', form: 'interior_decoration', budget_band: enq.budget }); } catch (eC) {}
        }
      } catch (eEnq) {}

      form.addEventListener('submit', function (e) {
        /* Honeypot + time-trap: silently drop bots */
        var hp = form.querySelector('input[name="contact[nickname]"]');
        if ((hp && hp.value) || (Date.now() - loadedAt < 1500)) { e.preventDefault(); return; }

        /* Validate all; focus + scroll to the first invalid field */
        var firstInvalid = null;
        fields.forEach(function (el) {
          el.dataset.touched = '1';
          if (!setState(el) && !firstInvalid) firstInvalid = el;
        });
        if (firstInvalid) {
          e.preventDefault();
          firstInvalid.focus();
          if (firstInvalid.scrollIntoView) firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }

        /* This store has Shopify spam-protection (CAPTCHA) on the contact form, and Shopify
           only attaches the CAPTCHA token during a genuine native submit. A JS-intercepted or
           script-triggered submit (fetch / form.submit()) is rejected with "Missing CAPTCHA
           token". So on a valid human submit we do NOT preventDefault and do NOT submit via JS:
           we only save the answers (to personalise the WhatsApp button after the reload) and
           fire the optional webhook, then let Shopify's native submit + CAPTCHA + email run. */
        var get = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
        try {
          sessionStorage.setItem('god_enq', JSON.stringify({
            name: get('contact[name]'), rooms: get('contact[Which rooms]'), budget: get('contact[Budget]')
          }));
        } catch (e2) {}

        /* Optional webhook (Google Sheet / CRM / budget tagging); keepalive lets it finish
           through the navigation that follows. Kept off the submit's critical path. */
        if (webhook) {
          try {
            var payload = {}; new FormData(form).forEach(function (v, k) { payload[k] = v; });
            fetch(webhook, { method: 'POST', mode: 'no-cors', body: JSON.stringify(payload), keepalive: true });
          } catch (e3) {}
        }

        /* No preventDefault on the valid path: Shopify's native submit + CAPTCHA proceed. */
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-section-type="interior-enquiry"]').forEach(initEnquiry);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interior-decoration-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__decoHeroBound) return;
    window.__decoHeroBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hero-scroll]');
      if (!btn) return;
      var section = btn.closest('[data-hero]');
      var next = section && section.nextElementSibling;
      if (next && next.scrollIntoView) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: Math.round(window.innerHeight * 0.9), behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interior-decoration-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dstoryReady) return;
      root.dstoryReady = true;

      var covers = Array.prototype.slice.call(root.querySelectorAll('[data-cover-btn]'));
      var tpls = Array.prototype.slice.call(root.querySelectorAll('[data-story-tpl]'));
      var player = root.querySelector('[data-stories-player]');
      if (!player || covers.length === 0) return;

      var barsEl = player.querySelector('[data-bars]');
      var stageEl = player.querySelector('[data-stage]');
      var headCover = player.querySelector('[data-head-cover]');
      var headTitle = player.querySelector('[data-head-title]');
      var frame = player.querySelector('[data-frame]');
      var prevBtn = player.querySelector('[data-prev]');
      var nextBtn = player.querySelector('[data-next]');
      var closeEls = Array.prototype.slice.call(player.querySelectorAll('[data-close]'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var data = tpls.map(function (t) {
        return {
          title: t.getAttribute('data-title') || '',
          cover: t.getAttribute('data-cover') || '',
          slides: Array.prototype.slice.call(t.content.querySelectorAll('.dstory-slide'))
        };
      });

      var hi = 0, si = 0, timer = null, video = null, current = null;
      var paused = false, remaining = 0, curMs = 0, barStart = 0, lastFocus = null;
      var holdTimer = null, holding = false, downX = 0, downY = 0;

      function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }
      function stopVideo() { if (video) { try { video.pause(); } catch (e) {} video = null; } }
      function fill(i) { var b = barsEl.children[i]; return b ? b.firstChild : null; }

      function buildBars(n) {
        barsEl.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('div');
          b.className = 'dstory-bar';
          var f = document.createElement('span');
          f.className = 'dstory-bar-fill';
          b.appendChild(f);
          barsEl.appendChild(b);
        }
      }

      function render() {
        clearTimer(); stopVideo(); paused = false;
        var d = data[hi];
        if (!d || d.slides.length === 0) { close(); return; }
        if (si < 0) si = 0;
        if (si >= d.slides.length) si = d.slides.length - 1;

        buildBars(d.slides.length);
        headTitle.textContent = d.title;
        headCover.style.backgroundImage = d.cover ? 'url("' + d.cover + '")' : 'none';
        for (var k = 0; k < barsEl.children.length; k++) {
          var f0 = fill(k);
          f0.style.transition = 'none';
          f0.style.transform = 'scaleX(' + (k < si ? 1 : 0) + ')';
        }

        stageEl.innerHTML = '';
        var node = d.slides[si].cloneNode(true);
        stageEl.appendChild(node);
        current = node;
        var type = node.getAttribute('data-type');

        var im = node.querySelector('img.dstory-media');
        if (im) {
          if (im.complete) im.classList.add('is-loaded');
          else im.addEventListener('load', function () { im.classList.add('is-loaded'); });
        }

        if (type === 'video') {
          var v = node.querySelector('video');
          video = v;
          if (v) {
            v.muted = true; v.playsInline = true;
            try { v.load(); } catch (e) {}
            try { v.currentTime = 0; } catch (e) {}
            v.addEventListener('timeupdate', videoBar);
            v.addEventListener('ended', next);
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else {
            startTimed(5000);
          }
        } else {
          var dur = parseInt(node.getAttribute('data-duration'), 10);
          if (!dur || dur < 1) dur = 5;
          startTimed(dur * 1000);
        }
      }

      function videoBar() {
        if (!video || !video.duration || isNaN(video.duration)) return;
        var f = fill(si);
        if (f) { f.style.transition = 'none'; f.style.transform = 'scaleX(' + (video.currentTime / video.duration) + ')'; }
      }

      function startTimed(ms) {
        curMs = ms; remaining = ms; barStart = Date.now();
        var f = fill(si);
        if (!f) return;
        if (reduce) { f.style.transform = 'scaleX(1)'; timer = setTimeout(next, ms); return; }
        f.style.transition = 'none'; f.style.transform = 'scaleX(0)';
        void f.offsetWidth;
        f.style.transition = 'transform ' + ms + 'ms linear';
        f.style.transform = 'scaleX(1)';
        timer = setTimeout(next, ms);
      }

      function next() {
        var d = data[hi];
        if (d && si < d.slides.length - 1) { si++; render(); }
        else if (hi < data.length - 1) { hi++; si = 0; render(); }
        else close();
      }
      function prev() {
        if (si > 0) { si--; render(); }
        else if (hi > 0) { hi--; si = 0; render(); }
        else render();
      }

      function pause() {
        if (paused) return;
        paused = true;
        clearTimer();
        if (video) { try { video.pause(); } catch (e) {} return; }
        var f = fill(si);
        if (f) {
          var elapsed = Date.now() - barStart;
          remaining = Math.max(0, curMs - elapsed);
          var frac = curMs > 0 ? Math.min(1, elapsed / curMs) : 0;
          f.style.transition = 'none';
          f.style.transform = 'scaleX(' + frac + ')';
        }
      }
      function resume() {
        if (!paused) return;
        paused = false;
        if (video) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); return; }
        var f = fill(si);
        if (!f) return;
        if (reduce) { f.style.transform = 'scaleX(1)'; timer = setTimeout(next, remaining); return; }
        barStart = Date.now(); curMs = remaining;
        void f.offsetWidth;
        f.style.transition = 'transform ' + remaining + 'ms linear';
        f.style.transform = 'scaleX(1)';
        timer = setTimeout(next, remaining);
      }

      function open(index) {
        hi = index; si = 0;
        lastFocus = document.activeElement;
        player.hidden = false;
        player.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);
        render();
        if (closeEls[0]) closeEls[0].focus();
      }
      function close() {
        clearTimer(); stopVideo();
        player.hidden = true;
        player.setAttribute('aria-hidden', 'true');
        stageEl.innerHTML = '';
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') prev();
        else if (e.key === 'ArrowRight') next();
      }

      covers.forEach(function (btn, i) { btn.addEventListener('click', function () { open(i); }); });
      closeEls.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); close(); }); });

      frame.addEventListener('pointerdown', function (e) {
        downX = e.clientX; downY = e.clientY; holding = false;
        holdTimer = setTimeout(function () { holding = true; pause(); }, 250);
      });
      frame.addEventListener('pointerup', function (e) {
        clearTimeout(holdTimer);
        var dy = e.clientY - downY, dx = e.clientX - downX;
        if (holding) { resume(); return; }
        if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { close(); }
      });
      frame.addEventListener('pointercancel', function () { clearTimeout(holdTimer); if (holding) resume(); });

      prevBtn.addEventListener('click', function () { if (holding) { holding = false; return; } prev(); });
      nextBtn.addEventListener('click', function () { if (holding) { holding = false; return; } next(); });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-stories-root]').forEach(init);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interior-decoration-what-we-do"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.wwdReady) return;
      root.wwdReady = true;

      var track = root.querySelector('[data-wwd-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wwd-slide]'));
      var n = slides.length;
      if (!track || n < 2) return;

      var scope = root.parentElement;
      var bars = Array.prototype.slice.call(scope.querySelectorAll('[data-wwd-bars] [data-wwd-goto]'));
      var fills = bars.map(function (b) { return b.querySelector('.wwd__bar-fill'); });
      var prevBtn = root.querySelector('[data-wwd-prev]');
      var nextBtn = root.querySelector('[data-wwd-next]');
      var curEl = scope.querySelector('[data-wwd-current]');
      var status = root.querySelector('[data-wwd-status]');
      var toggleBtn = scope.querySelector('[data-wwd-toggle]');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canAuto = root.getAttribute('data-autoplay') === 'true' && !reduce;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var pauseHover = root.getAttribute('data-pause-hover') !== 'false';

      var index = 0, timer = null, barStart = 0;
      var dragging = false, startX = 0, dx = 0, vw = 0;
      var paused = { hover: false, focus: false, hidden: false, off: false, drag: false, user: false };

      function pad(x) { return (x < 10 ? '0' : '') + x; }
      function anyPaused() { for (var k in paused) { if (paused[k]) return true; } return false; }
      function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }
      function schedule() { clearTimer(); if (canAuto && !anyPaused()) { timer = setTimeout(function () { setActive(index + 1); }, interval); } }

      function fillActive() {
        var f = fills[index];
        if (!f) return;
        f.style.transition = 'none';
        f.style.transform = 'scaleX(0)';
        if (canAuto && !anyPaused()) { void f.offsetWidth; barStart = Date.now(); f.style.transition = 'transform ' + interval + 'ms linear'; f.style.transform = 'scaleX(1)'; }
        else { f.style.transform = 'scaleX(1)'; }
      }

      function setActive(i) {
        index = ((i % n) + n) % n;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        fills.forEach(function (f, j) { if (f) { f.style.transition = 'none'; f.style.transform = 'scaleX(' + (j < index ? 1 : 0) + ')'; } });
        bars.forEach(function (b, j) { b.setAttribute('aria-current', j === index ? 'true' : 'false'); });
        if (curEl) curEl.textContent = pad(index + 1);
        if (status) status.textContent = 'Slide ' + (index + 1) + ' of ' + n;
        clearTimer();
        if (anyPaused()) { var f = fills[index]; if (f) { f.style.transition = 'none'; f.style.transform = canAuto ? 'scaleX(0)' : 'scaleX(1)'; } }
        else { fillActive(); schedule(); }
      }

      function setPause(k, v) {
        if (paused[k] === v) return;
        paused[k] = v;
        if (anyPaused()) { clearTimer(); var f = fills[index]; if (f) { var frac = interval > 0 ? Math.min(1, (Date.now() - barStart) / interval) : 0; f.style.transition = 'none'; f.style.transform = 'scaleX(' + frac + ')'; } }
        else { fillActive(); schedule(); }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(index + 1); });
      bars.forEach(function (b) { b.addEventListener('click', function () { setActive(parseInt(b.getAttribute('data-wwd-goto'), 10)); }); });

      if (pauseHover) {
        root.addEventListener('mouseenter', function () { setPause('hover', true); });
        root.addEventListener('mouseleave', function () { setPause('hover', false); });
      }
      root.addEventListener('focusin', function () { setPause('focus', true); });
      root.addEventListener('focusout', function () { setPause('focus', false); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); setActive(index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); setActive(index + 1); }
      });
      document.addEventListener('visibilitychange', function () { setPause('hidden', document.hidden); });

      track.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; dx = 0; vw = root.getBoundingClientRect().width || 1;
        setPause('drag', true); track.style.transition = 'none';
        if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX;
        track.style.transform = 'translateX(' + ((-index * vw) + dx) + 'px)';
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        var moved = Math.abs(dx) > vw * 0.15;
        var dir = dx < 0 ? 1 : -1;
        paused.drag = false;
        setActive(moved ? index + dir : index);
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { setPause('off', !e.isIntersecting); });
        }, { threshold: 0.15 }).observe(root);
      }

      if (toggleBtn) {
        if (canAuto) { toggleBtn.hidden = false; }
        toggleBtn.addEventListener('click', function () {
          var willPause = !paused.user;
          toggleBtn.classList.toggle('is-paused', willPause);
          toggleBtn.setAttribute('aria-label', willPause ? 'Play slideshow' : 'Pause slideshow');
          setPause('user', willPause);
        });
      }

      setActive(0);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-wwd-slider]').forEach(initSlider);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
